import { Pipe, PipeTransform } from '@angular/core';
import { StatistikIgangvaerendeKunde } from '../../models/StatistikIgangvaerendeKunde';

@Pipe({
    name: 'calcTotalForventetTab',
    standalone: false
})
export class CalcTotalForventetTabPipe implements PipeTransform {
    transform(kunder: StatistikIgangvaerendeKunde[]): number {
        return kunder.reduce((previousValue, currentValue) => previousValue + currentValue.forventedTab, 0);
    }
}
